import React from 'react'
import { PullToRefreshContainer } from '@mobi/component-library/Common/PullToRefreshContainer'
import { useScrollRestoreOverride } from '@core/Areas/AppHeader/Components/ScrollRestoration/hooks'
import { triggerHapticFeedback } from '@core/Utils/hapticFeedback/hapticFeedback'
import { FeedContainerStyled } from '@core/Areas/BetLoop/Components/Common/BetLoop.styles'
import { SkeletonLoader } from '@core/Areas/BetLoop/Components/Common/SkeletonLoader'
import { SharedBetCard } from '@core/Areas/BetLoop/Components/Common/SharedBetCard'
import { SortFeed } from '@core/Areas/BetLoop/Components/Common/SortFeed'
import { useSharedBetsData } from '@core/Areas/BetLoop/hooks/useSharedBetsData'
import type { SortFilter, SortOrder } from '@core/Areas/BetLoop/types'
import { QuickShareButton } from '@core/Areas/BetLoop/Components/QuickShareButton'
import { EmptyMessage } from '@core/Areas/BetLoop/Components/Common/EmptyMessage'
import { useRefetchFeedDataOnBetslipClosed } from '@core/Areas/BetLoop/hooks/useRefetchFeedDataOnBetslipClosed'

let sessionSortOrder: SortOrder = 'sortAsc'
let sessionSortFilder: SortFilter = 'JumpTime'

export const ExploreFeed: React.FC = () => {
  useRefetchFeedDataOnBetslipClosed('explore')

  const [sortOrder, setSortOrder] = React.useState<SortOrder>(sessionSortOrder)
  const [sortFilter, setSortFilter] = React.useState<SortFilter>(sessionSortFilder)

  React.useEffect(() => {
    sessionSortOrder = sortOrder
    sessionSortFilder = sortFilter
  }, [sortFilter, sortOrder])

  const { isLoading, data, refetch, LoadMoreButton, isEmptyState } = useSharedBetsData({
    sortFilter,
    sortOrder,
    feedType: 'explore',
  })

  const shouldRenderLoader = isLoading || !data
  useScrollRestoreOverride({ hasPageLoaded: !shouldRenderLoader && !isEmptyState })

  if (isEmptyState) {
    return (
      <>
        <EmptyMessage
          messageType='explore'
          title='No Shared Bets'
          description={`There aren't any bets shared\n right now. Be the first to share\n yours!`}
        />

        <QuickShareButton />
      </>
    )
  }

  return (
    <>
      <SortFeed
        sortFilter={sortFilter}
        sortOrder={sortOrder}
        handleSortFilterChange={setSortFilter}
        handleSortOrderChange={setSortOrder}
      />

      <PullToRefreshContainer
        onRefresh={refetch}
        onReachingRefreshThreshold={triggerHapticFeedback}
        skeletonLoader={
          <FeedContainerStyled>
            <SkeletonLoader />
          </FeedContainerStyled>
        }
        isLoading={shouldRenderLoader}
      >
        <FeedContainerStyled>
          {data?.pages.map(feedPage =>
            feedPage.map(sharedBet => (
              <SharedBetCard key={sharedBet.postId} sharedBet={sharedBet} />
            ))
          )}

          <LoadMoreButton />
        </FeedContainerStyled>
      </PullToRefreshContainer>

      <QuickShareButton />
    </>
  )
}
